import { render, staticRenderFns } from "./NpcPrint.vue?vue&type=template&id=28075e6d&scoped=true&"
import script from "./NpcPrint.vue?vue&type=script&lang=ts&"
export * from "./NpcPrint.vue?vue&type=script&lang=ts&"
import style0 from "./NpcPrint.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NpcPrint.vue?vue&type=style&index=1&id=28075e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28075e6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow,VSpacer})
